import request from "../request";
import Url from "../url/record";

const getRecordHeartbeatBloodPressureList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getRecordHeartbeatBloodPressureList + path,
    data,
    options
  );
};
const getMyRecordHeartbeatBloodPressureList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getMyRecordHeartbeatBloodPressureList + path,
    data,
    options
  );
};
const getRecordHeartbeatBloodPressureDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getRecordHeartbeatBloodPressureDetails + path,
    data,
    options
  );
};
const setRecordHeartbeatBloodPressureData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.setRecordHeartbeatBloodPressureData + path,
    data,
    options
  );
};
const updateRecordHeartbeatBloodPressureData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.updateRecordHeartbeatBloodPressureData + path,
    data,
    options
  );
};
const deleteRecordHeartbeatBloodPressureData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.deleteRecordHeartbeatBloodPressureData + path,
    data,
    options
  );
};

const getRecordWeightList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getRecordWeightList + path, data, options);
};
const getMyRecordWeightList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getMyRecordWeightList + path, data, options);
};
const getRecordWeightDetails = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getRecordWeightDetails + path, data, options);
};
const setRecordWeightData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setRecordWeightData + path, data, options);
};
const updateRecordWeightData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateRecordWeightData + path, data, options);
};
const deleteRecordWeightData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.deleteRecordWeightData + path, data, options);
};

const getRecordGlucoseList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getRecordGlucoseList + path, data, options);
};
const getMyRecordGlucoseList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getMyRecordGlucoseList + path, data, options);
};
const getRecordGlucoseDetails = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getRecordGlucoseDetails + path, data, options);
};
const setRecordGlucoseData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setRecordGlucoseData + path, data, options);
};
const updateRecordGlucoseData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateRecordGlucoseData + path, data, options);
};
const deleteRecordGlucoseData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.deleteRecordGlucoseData + path, data, options);
};

const getRecordUncomfortableSymptomsList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getRecordUncomfortableSymptomsList + path,
    data,
    options
  );
};
const getMyRecordUncomfortableSymptomsList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getMyRecordUncomfortableSymptomsList + path,
    data,
    options
  );
};
const getRecordUncomfortableSymptomsDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getRecordUncomfortableSymptomsDetails + path,
    data,
    options
  );
};
const setRecordUncomfortableSymptomsData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.setRecordUncomfortableSymptomsData + path,
    data,
    options
  );
};
const updateRecordUncomfortableSymptomsData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.updateRecordUncomfortableSymptomsData + path,
    data,
    options
  );
};
const deleteRecordUncomfortableSymptomsData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(
    Url.deleteRecordUncomfortableSymptomsData + path,
    data,
    options
  );
};

const getRecordHealthBehaviorList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getRecordHealthBehaviorList + path, data, options);
};
const getMyRecordHealthBehaviorList = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getMyRecordHealthBehaviorList + path, data, options);
};
const getRecordHealthBehaviorDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getRecordHealthBehaviorDetails + path, data, options);
};
const setRecordHealthBehaviorData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(Url.setRecordHealthBehaviorData + path, data, options);
};
const updateRecordHealthBehaviorData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(Url.updateRecordHealthBehaviorData + path, data, options);
};
const deleteRecordHealthBehaviorData = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(Url.deleteRecordHealthBehaviorData + path, data, options);
};

const downloadCaseData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.downloadCaseData + path, data, options);
};

export default {
  getRecordHeartbeatBloodPressureList,
  getMyRecordHeartbeatBloodPressureList,
  getRecordHeartbeatBloodPressureDetails,
  setRecordHeartbeatBloodPressureData,
  updateRecordHeartbeatBloodPressureData,
  deleteRecordHeartbeatBloodPressureData,

  getRecordWeightList,
  getMyRecordWeightList,
  getRecordWeightDetails,
  setRecordWeightData,
  updateRecordWeightData,
  deleteRecordWeightData,

  getRecordGlucoseList,
  getMyRecordGlucoseList,
  getRecordGlucoseDetails,
  setRecordGlucoseData,
  updateRecordGlucoseData,
  deleteRecordGlucoseData,

  getRecordUncomfortableSymptomsList,
  getMyRecordUncomfortableSymptomsList,
  getRecordUncomfortableSymptomsDetails,
  setRecordUncomfortableSymptomsData,
  updateRecordUncomfortableSymptomsData,
  deleteRecordUncomfortableSymptomsData,

  getRecordHealthBehaviorList,
  getMyRecordHealthBehaviorList,
  getRecordHealthBehaviorDetails,
  setRecordHealthBehaviorData,
  updateRecordHealthBehaviorData,
  deleteRecordHealthBehaviorData,

  downloadCaseData,
};
